import { LoaderComponent } from './loader.component';

export const LOADER_DECLARATIONS: any[] = [LoaderComponent];
